import { useEffect, useState } from "react";
import { QUESTIONS } from "@/components/candidati/sim/simData";

const LINES = [
  "Inizializzazione motore psicometrico…",
  `Normalizzazione delle risposte [${QUESTIONS.length}/${QUESTIONS.length}]`,
  "Calcolo vettori su 6 dimensioni",
  "Identificazione archetipo comportamentale",
  "Generazione grafico a radar",
];

export const SimProcessing = ({ onDone }) => {
  const [shown, setShown] = useState(1);
  useEffect(() => {
    const id = setInterval(() => setShown((v) => Math.min(v + 1, LINES.length)), 380);
    const t = setTimeout(onDone, 2000);
    return () => {
      clearInterval(id);
      clearTimeout(t);
    };
  }, [onDone]);

  return (
    <div className="sim-step py-6" data-testid="sim-processing">
      <p className="font-mono text-xs tracking-[0.25em] uppercase text-cyan">Elaborazione Dati</p>
      <div className="mt-6 space-y-2 font-mono text-sm min-h-[150px]">
        {LINES.slice(0, shown).map((l, i) => (
          <p key={l} className={i === shown - 1 ? "text-white" : "text-titanium"}>
            <span className="text-cyan">[OK]</span> {l}
          </p>
        ))}
      </div>
      <div className="mt-6 h-1.5 rounded-full bg-white/[0.06] overflow-hidden">
        <div className="sim-progress h-full bg-[#00e5ff] shadow-[0_0_12px_#00e5ff]" />
      </div>
    </div>
  );
};
